import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Flex, Text } from '../../primitives';

type Props = {
  className?: string;
  commonCount: number;
  otherGender?: any;
  title?: string;
  withCommonInterestsPhrase?: boolean;
};

const ChipsListTitleWithCommonInterest = ({
  className,
  commonCount,
  otherGender,
  title,
  withCommonInterestsPhrase = false,
}: Props) => {
  const { t } = useTranslation();

  const count = commonCount;

  return (
    <div className={className}>
      <Flex
        mb={['0px', '1rem']}
        mt={['1.5rem', 0]}
        flexWrap="wrap"
        fontSize={['size16', 'size24']}
        fontWeight={600}
        whiteSpace="pre-wrap"
        color={['primary', 'primary'] as any}
      >
        <Trans
          i18nKey={title}
          values={{
            MY_WANTED_GENDER: otherGender,
          }}
          components={[
            <Text
              key={'text1'}
              fontSize={['size16', 'size24']}
              fontWeight={600}
              whiteSpace="pre-wrap"
              color={['primary', 'primary'] as any}
            ></Text>,
            <Text
              key={'text2'}
              fontSize={['size16', 'size24']}
              fontWeight={600}
              whiteSpace="pre-wrap"
              color={['hippieBlue', 'hippieBlue'] as any}
            ></Text>,
          ]}
        />
      </Flex>

      {withCommonInterestsPhrase && commonCount > 0 && (
        <Box mt={['0px', '.5rem']}>
          <Flex flexWrap="wrap">
            <Trans
              i18nKey="userAndMe.interestCount"
              values={{
                count,
                common: t('userAndMe.common'),
              }}
              components={[
                <Text key="count" whiteSpace="pre-wrap">
                  You have {count} interest in
                </Text>,
                <Text
                  key="chip"
                  whiteSpace="pre-wrap"
                  fontWeight={600}
                  color={['hippieBlue', 'hippieBlue'] as any}
                >
                  {t('userAndMe.common')}
                </Text>,
              ]}
            />
          </Flex>
        </Box>
      )}
    </div>
  );
};

export default ChipsListTitleWithCommonInterest;
